import { render, staticRenderFns } from "./PricingHub.vue?vue&type=template&id=0e96b03c&"
import script from "./PricingHub.vue?vue&type=script&lang=js&"
export * from "./PricingHub.vue?vue&type=script&lang=js&"
import style0 from "./PricingHub.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports